import React from "react";
import { isValNull, getPath, isEmpty } from "../../../utils/index";
import styled from "styled-components";
import Share from "sushiweb/Icons/all/Share";
import { InfoLine } from "sushiweb/Icons";
import { Tooltip } from "@material-ui/core";
import variables from "../../../constants/assets/variables";
import { getDashboardUrl } from "../../../views/Home";

const OrderProgress = (props) => {
  const { details, trackingLink } = props;

  const openOrderRun = (shipment_ref_id) => {
    if (!shipment_ref_id) {
      return;
    }
    const url = `${getDashboardUrl()}/tracking/track?id=${shipment_ref_id}`;
    window.open(url);
  };

  const getDetails = (details) => {
    if (isValNull(details)) {
      return <p>Details not available</p>;
    }

    const transformedDetails = Object.keys(details).map((key) => {
      if (isValNull(details[key])) {
        return <></>;
      }

      return (
        <div>
          <p
            style={{
              display: "inline-block",
              width: "10rem",
              textAlign: "left",
            }}
          >
            {key}:
          </p>
          <p
            style={{
              display: "inline-block",
              textAlign: "right",
              marginLeft: "10px",
            }}
          >
            {details[key]}
          </p>
        </div>
      );
    });

    return transformedDetails;
  };

  const TimelineElement = (props) => {
    const { stateReachedAt, stateType } = props;

    return (
      <HeadingWrapper>
        <p>{stateReachedAt ? stateReachedAt : "--"}</p>
        <p>{stateType}</p>
      </HeadingWrapper>
    );
  };

  const ViewOrderRun = (props) => {
    return (
      <Tooltip
        title={
          props.shipment_ref_id
            ? "Track Order run here"
            : "Order Run is not available"
        }
        arrow
        placement={"top-end"}
        followCursor
      >
        <div
          className={"id_heading"}
          onClick={() => openOrderRun(props.shipment_ref_id)}
          disabled={!props.shipment_ref_id}
        >
          <Share size="0.8rem" color="#50b547" />
          <p style={{ color: "#50b547" }}> View Order Run</p>
        </div>
      </Tooltip>
    );
  };

  const openCrystalTracking = (link) => {
    if (!link) {
      return;
    }
    window.open(link, "_blank");
  };

  const ViewCrystalTracking = (props) => {
    return (
      <Tooltip
        title={"Crystal tracking here"}
        arrow
        placement={"top-end"}
        followCursor
      >
        <div
          className={"id_heading"}
          onClick={() => openCrystalTracking(props.shipment_ref_id)}
          disabled={!props.shipment_ref_id}
        >
          <Share size="0.8rem" color={variables.red500} />
          <p style={{ color: variables.red500 }}>Crystal tracking</p>
        </div>
      </Tooltip>
    );
  };

  if (isValNull(details) || isEmpty(details.order_states)) {
    return <></>;
  }

  return (
    <TimeLineCardWrapper>
      <TimeHeader>
        <div>
          <Tooltip
            title={getDetails(details.estimated_details)}
            arrow
            placement={"top-start"}
          >
            <div className={"id_heading"}>
              <InfoLine size="0.8rem" color="#2781e7" />
              <p> Estimated Trip Details </p>
            </div>
          </Tooltip>
        </div>
        <div>
          <Tooltip
            title={getDetails(details.otp_details)}
            arrow
            placement={"top-end"}
          >
            <div className={"id_heading"}>
              <InfoLine size="0.8rem" color="#2781e7" />
              <p> OTP Details </p>
            </div>
          </Tooltip>
          <ViewOrderRun shipment_ref_id={details.shipment_ref_id} />
          {trackingLink && (
            <ViewCrystalTracking shipment_ref_id={trackingLink} />
          )}
        </div>
      </TimeHeader>
      <TimeLineWrapper>
        <TimeLineDivider />
        <TimeLineElementsWrapper>
          {getPath(details, "order_states", []).map((orderState) => (
            <TimelineElement
              stateReachedAt={orderState.state_captured_at}
              stateType={orderState.state}
            />
          ))}
        </TimeLineElementsWrapper>
      </TimeLineWrapper>
    </TimeLineCardWrapper>
  );
};

const TimeLineCardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 100%;
  background-color: #f6f9fd;
  border-radius: 10px;
  border: 1px solid #e8e8e8;

  .id_heading {
    font-weight: bold;
    display: flex;
    justify-content: center;
    padding: 0.5rem 1.1rem;
    margin: 10px;
    font-size: 0.8rem !important;
    background: #fff;
    box-shadow: 0 4px 8px rgb(0 0 0 / 10%);
    border-radius: 0.5rem;
    color: #2781e7;
    cursor: pointer;

    p {
      padding: 2px;
    }
  }
`;

const TimeLineDivider = styled.div`
  border: 1px solid #539cee;
  height: 1px;
`;

const TimeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const TimeLineElementsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

const TimeLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  margin: 15px;
`;

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-size: 1rem !important;
  }
`;

export default OrderProgress;
